import EpisodeCardHeader from './EpisodeCardHeader';

export default EpisodeCardHeader;
